import {
  CheckCircle2,
  FolderTree,
  UtensilsCrossed,
} from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useLanguage } from '../../contexts/LanguageContext';
import '../../styles/menu-import/menu-import.css';

export default function MenuImportSuccess() {
  const navigate = useNavigate();
  const { t, language } = useLanguage();

  const direction = String(language || '')
    .toLowerCase()
    .startsWith('ar')
    ? 'rtl'
    : 'ltr';

  return (
    <main
      className="menu-import-page"
      dir={direction}
    >
      <section className="menu-import-success">
        <CheckCircle2 size={56} />

        <h1>
          {t('aiImport.success.title')}
        </h1>

        <p>
          {t('aiImport.success.description')}
        </p>

        <div className="menu-import-success__actions">
          <button
            type="button"
            onClick={() =>
              navigate('/categories')
            }
          >
            <FolderTree size={18} />

            {t(
              'aiImport.success.categories',
            )}
          </button>

          <button
            type="button"
            onClick={() =>
              navigate('/products')
            }
          >
            <UtensilsCrossed size={18} />

            {t(
              'aiImport.success.products',
            )}
          </button>
        </div>
      </section>
    </main>
  );
}
